export default "__VITE_ASSET__Bpz11LHm__"